import React from 'react';
import { useInView, useRevealOnMount } from '../hooks/useInView';

const VARIANT_CLASS = {
  'fade-up': 'reveal-fade-up',
  'fade-down': 'reveal-fade-down',
  'fade-left': 'reveal-fade-left',
  'fade-right': 'reveal-fade-right',
  'fade-in': 'reveal-fade-in',
  scale: 'reveal-scale',
};

const AnimateIn = ({
  children,
  className = '',
  variant = 'fade-up',
  delay = 0,
  immediate = false,
  as: Tag = 'div',
  threshold,
  rootMargin,
}) => {
  const [ref, isInView] = useInView({ threshold, rootMargin });
  const isReady = useRevealOnMount();
  const isVisible = immediate ? isReady : isInView;
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS['fade-up'];

  return (
    <Tag
      ref={ref}
      className={`reveal ${variantClass} ${isVisible ? 'reveal-visible' : ''} ${className}`}
      style={{ '--reveal-delay': `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default AnimateIn;
